import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementRevoked_Agreement on AgreementType {
            isRevoked
        }
    `),
}

type IsAgreementRevokedProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementRevoked(props: IsAgreementRevokedProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return !!agreement.isRevoked
}

isAgreementRevoked.fragments = graphQLFragments
